import BasePage from "@Scripts/Pages/BasePage";

export default class HomePage extends BasePage {
    public static async init() {
        await super.init();

        if ((<any>window).App.bag.VideoId) {
            this.setYoutubeBox();
        }
    }

    private static setYoutubeBox() {
        let tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";

        let firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        let self = this;
        window["onYouTubeIframeAPIReady"] = function () {
            let player = new window["YT"].Player("Player", {
                host: "https://www.youtube.com",
                videoId: (<any>window).App.bag.VideoId,
                playerVars: {
                    fs: 0,
                    rel: 0,
                    showinfo: 0,
                    controls: 0,
                    modestbranding: 1,
                    iv_load_policy: 3,
                    autohide: 0
                },
                events: {
                    "onReady": self.onPlayerReady,
                    "onStateChange": self.onStateChange
                }
            });
        }
    }

    private static onPlayerReady(event) {
        event.target.setVolume(0);
        event.target.playVideo();
    }

    private static onStateChange(event) {
        if (event.data == window["YT"].PlayerState.ENDED) {
            event.target.playVideo();
        }
    }
}